<section class="content-header">

    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-8">
          <h1 class="m-0 text-dark">
            State Wise Food Safety On Wheels (FSW)</h1>
        </div>
  
      </div>
      
      <!-- /.row -->
    </div>
    <!-- /.container-fluid -->
  </section>
  <section class="content">
    <!-- Default box -->
    <div class="container-fluid">
  
      <div class="card">
  
        <div class="card-body">
         
          <div class="row">
            <div class="col-md-6">
              <div id='appOnlineChartDiv' style="width:100%;height: 600px;"></div>
            </div>
            <div class="col-md-6">
              <div class="row" *ngIf="role!='IT-TEAM'">
                <!-- <div class="col-md-12" >
                  <p style="float:right"><a [routerLink]="['/','add-vehicle']"  class="btn btn-link">Add New Vehicle</a></p>
                </div> -->
              </div>
              <table class="table table-striped table-hover table-bordered">
                <thead>
                  <tr>
                    <td style="font-weight:bold;" colspan="2">Total Number Of Vehicles</td>
                    <td><b>{{totalVehicle}}</b></td>
                  </tr>
                  <tr>
                    <td style="font-weight:bold;">Sr No</td>
                    <td style="font-weight:bold">State Name</td>
                    <td style="font-weight:bold">No. of Vehicles</td>
                  </tr>
                </thead>
  
                <tbody>
                  <tr *ngFor="let vehicle of vehiclesData | paginate : {itemsPerPage: 50, currentPage : p}; let i=index">
                    <td>{{ itemsPerPage * (p - 1) + i + 1 }}</td>
                    <td>{{ vehicle.stateName }}</td>
                    <td><a [routerLink]="['/','list-vehicle-home',vehicle.stateCode]" >{{ vehicle.total }}</a></td>               
                  </tr>           
                </tbody>
                
              </table>
              <!-- <pagination-controls (pageChange)="p = $event" class="float-right"></pagination-controls> -->
            </div>
          </div>
        </div>
      </div>
      </div>
  </section>
  